import { action, set } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { Task } from 'ember-concurrency';
import type LocationModel from 'garaje/models/location';
import type ImpressionsService from 'garaje/services/impressions';
import type MetricsService from 'garaje/services/metrics';
import { IMPRESSION_NAMES } from 'garaje/utils/enums';

interface TouchlessSignInComponentSignature {
  Args: {
    location: LocationModel;
    saveTask: Task<void, [LocationModel]>;
  };
}

export default class TouchlessSignInComponent extends Component<TouchlessSignInComponentSignature> {
  @service declare impressions: ImpressionsService;
  @service declare metrics: MetricsService;

  @action
  async toggleSetting(): Promise<void> {
    const { location, saveTask } = this.args;
    set(location, 'touchlessSigninEnabled', !location.touchlessSigninEnabled);
    await saveTask.perform(location);
    await this._trackSettingToggled(location.touchlessSigninEnabled);
  }

  async _trackSettingToggled(value: boolean): Promise<void> {
    const { location } = this.args;
    const name = 'Pre-registration - Touchless Sign In Setting Toggled';
    this.metrics.trackEvent(name, { toggle_state_after_click: value });
    await this.impressions.postImpression.perform(
      IMPRESSION_NAMES.VR_INVITES_TOUCHLESS_SIGN_IN[location.touchlessSigninEnabled ? 'ENABLED' : 'DISABLED'],
    );
  }
}
